import { post } from "@utils/axios";

export const getReleaseNotesReq = (payload = {}) => post("release_notes", payload);
